<template>
  <div class="hot-box-title" :style="styleCss">
    <div class="title">
      {{ title }}
      <div class="Underline"></div>
    </div>
    <div class="more" v-if="title2" @click="more">{{ title2 }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "title",
    },
    title2: {
      type: String,
      default: "",
    },
    styleCss: {
      type: String,
      default: "",
    },
  },
  name: "TitlePage",
  data() {
    return {};
  },
  methods: {
    more() {
      this.$emit("more");
    },
  },
};
</script>
<style lang="scss" scoped>
.hot-box-title {
  font-size: 0.36rem;
  color: #303030;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;

  .title {
    width: fit-content;
    .Underline {
      background: #ae6bf7;
      height: 2px;
    }
  }
  .more {
    color: #ae6bf7;
  }
}
</style>
